// extracted by mini-css-extract-plugin
module.exports = {"watchlistItem":"WatchlistItem_watchlistItem__zADEa","text":"WatchlistItem_text__mk2k3","trashIcon":"WatchlistItem_trashIcon__aJ5aD"};